import React, { Fragment, useEffect } from "react";
import "../CSS/Resume.css";
import Aos from "aos";
import "aos/dist/aos.css";

const Resume = () => {
  useEffect(() => {
    Aos.init({ duration: 2000, once: true, easing: "ease" });
  });
  return (
    <Fragment>
      <section className="resume">
        <div className="main-title">
          <h2 className="purple">
            <strong>Professional Experience</strong>
          </h2>
        </div>

        <div className="res-data">
          <div className="timeline">
            <ul>
              <li>
                <div data-aos="fade-right" className="content">
                  <h4>
                    <strong>Carousell Group </strong>
                  </h4>
                  <span>
                    <strong>Software engineer intern</strong>
                  </span>
                  <span>Jan 2024 - present</span>

                  <p>
                    Working as an Backend software development engineer (SDE) intern in the 
                    Trust team of the Carousell core marketplace.
                  </p>
                </div>
              </li>
              <li>
                <div data-aos="fade-right" className="content">
                  <h4>
                    <strong>SCALER</strong>
                  </h4>
                  <span>
                    <strong>Teaching Assistant</strong>
                  </span>
                  <span>Sept 2022 - Jun 2023</span>

                  <p>
                    Working as an Online Teaching Assistant (TA) for various
                    batches of DSA and Competitive Programming. 
                  </p>
                  <p>
                    Responsible for
                    monitoring student progress and Organize interactive doubt
                    solving sessions.

                  </p>
                </div>
              </li>
              <li>
                <div data-aos="fade-left" className="content">
                  <h4>
                    <strong>PCON</strong>
                  </h4>
                  <span>
                    <strong>Event Head</strong>
                  </span>
                  <span>Dec 2022 - present</span>

                  <p>
                    PCON is the programming club of our college. Organised
                    Workshops, Hackathons, Coding Contest and other programming
                    events.
                  </p>
                  <p>
                    Provide mentorship to juniors on various Computer Science topics.
                  </p>
                  <hr />
                  <span>
                    <strong>Member</strong>
                  </span>
                  <span>March 2022 - Dec 2022</span>

                  <p>
                    Member of Competitive Programming Wing.
                    Organised Workshops on Advanced Data Structures and Algorithms.
                    
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default Resume;
